export const topics = [
  {
    id: "t01",
    title: "音乐节迁徙计划",
    subtitle: "当现场不再只属于体育馆",
    cover:
      "https://readdy.ai/api/search-image?query=Wide%20outdoor%20music%20festival%20at%20golden%20hour%20with%20warm%20orange%20stage%20lights%20and%20haze%20over%20a%20large%20crowd%2C%20stylized%20editorial%20poster%20art%2C%20deep%20charcoal%20shadows%2C%20grainy%20texture%2C%20cinematic%20contrast&width=1600&height=900&seq=lulu-topic-01&orientation=landscape",
    intro:
      "从体育馆到草坪，从单场演出到一整天的体验，华语乐坛的现场版图正在被重新绘制。这个专题我们想聊清楚三件事：观众为什么改变、音乐人如何应对、以及现场的未来会长什么样。",
    review:
      "编辑点评：这不是一次简单的场地转移，而是整个现场经济从「卖一张票」到「卖一段时光」的范式变化。谁能把体验做扎实，谁就能在下半场胜出。",
    articleIds: ["a01", "a05", "a09", "a13"],
    relatedTopicIds: ["t02", "t04"],
    date: "2026-10-12",
  },
  {
    id: "t02",
    title: "年度华语影视观察",
    subtitle: "类型、口碑与观众的新契约",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinema%20hall%20with%20warm%20projector%20beam%20and%20rows%20of%20empty%20seats%2C%20editorial%20poster%20art%2C%20deep%20charcoal%20with%20amber%20glow%2C%20grainy%20texture%2C%20cinematic%20contrast&width=1600&height=900&seq=lulu-topic-02&orientation=landscape",
    intro:
      "票房在变、类型在变、观众也在变。我们复盘了这一年华语影视的关键节点：哪些类型真正跑通，哪些口碑逆袭，哪些尝试值得被记住。",
    review:
      "编辑点评：当视觉奇观不再稀缺，好故事重新成为硬通货。这一年的最大赢家，无一例外都赢在了「讲清楚一件事」的能力上。",
    articleIds: ["a02", "a06", "a10", "a14"],
    relatedTopicIds: ["t01", "t03"],
    date: "2026-10-11",
  },
  {
    id: "t03",
    title: "复古回潮 · Y2K 再定义",
    subtitle: "这一代人的怀旧，从不是复制",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20retro%20Y2K%20aesthetic%20composition%20with%20chrome%20shapes%20glossy%20plastic%20and%20soft%20pink%20light%2C%20editorial%20poster%20art%2C%20warm%20orange%20and%20silver%20accents%20on%20cream%2C%20grainy%20texture%2C%20playful%20layout&width=1600&height=900&seq=lulu-topic-03&orientation=landscape",
    intro:
      "千禧年的色彩、轮廓与乐观主义被重新搬回视野。但 Z 世代并不满足于复刻——他们把它拆开、重组，变成属于自己的语言。",
    review:
      "编辑点评：复古从来不是回到过去，而是把过去当作材料。这个专题里的每一个案例，都在证明「旧元素」可以讲出「新故事」。",
    articleIds: ["a08", "a03", "a11", "a12"],
    relatedTopicIds: ["t04", "t02"],
    date: "2026-10-05",
  },
  {
    id: "t04",
    title: "街头文化三十年",
    subtitle: "从城市角落到美术馆展厅",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20urban%20concrete%20wall%20with%20abstract%20graffiti%20shapes%20and%20long%20afternoon%20shadows%2C%20editorial%20poster%20art%2C%20grey%20concrete%20with%20orange%20and%20blue%20accents%2C%20grainy%20texture%2C%20minimal%20composition&width=1600&height=900&seq=lulu-topic-04&orientation=landscape",
    intro:
      "滑板、涂鸦、街舞，这些曾经的城市噪音，如今成了主流文化的灵感源。这个专题梳理了街头文化被收编、又不断自我更新的三十年。",
    review:
      "编辑点评：街头文化的核心从来不是某个单品，而是一种「自己动手」的态度。只要这种态度还在，它就永远不会真正被收编。",
    articleIds: ["a04", "a12", "a11", "a08"],
    relatedTopicIds: ["t03", "t01"],
    date: "2026-10-09",
  },
];